export default __webpack_public_path__ + "static/media/instagram.24f17306.png";